module.exports = __webpack_public_path__ + "media/images/f_logo-a21885c72e5624603e04a65e80e820d7.png";